(function () {
  'use strict';

  /* ── Scroll-reveal ──────────────────────────────────────────── */
  var revealEls = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ro.unobserve(e.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -36px 0px' });
    /* threshold 0: reveal as soon as any part is on screen. With a fractional threshold, a block
       taller than the screen divided by that fraction (a long blog post on a phone) never
       reaches it and stays invisible. */

    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ── Counter animation ──────────────────────────────────────── */
  var countersRun = false;
  var benefitsSection = document.querySelector('.benefits');

  function runCounters() {
    if (countersRun) return;
    countersRun = true;

    document.querySelectorAll('[data-target]').forEach(function (el) {
      var target   = parseInt(el.getAttribute('data-target'), 10);
      var countEl  = el.querySelector('.js-count');
      if (!countEl) return;

      var duration = 1600;
      var t0       = null;

      function tick(ts) {
        if (!t0) t0 = ts;
        var p    = Math.min((ts - t0) / duration, 1);
        /* Ease-out cubic */
        var ease = 1 - Math.pow(1 - p, 3);
        countEl.textContent = Math.round(ease * target);
        if (p < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    });
  }

  if (benefitsSection && 'IntersectionObserver' in window) {
    var co = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) { runCounters(); co.disconnect(); }
    }, { threshold: 0.25 });
    co.observe(benefitsSection);
  }

  /* ── Smooth anchor scroll ───────────────────────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
